// src/main.jsx
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { registerSW } from "virtual:pwa-register";
import { AuthProvider } from "./context/AuthContext";
import ErrorBoundary from "./components/ErrorBoundary";
import NavigationErrorBoundary from "./components/NavigationErrorBoundary";
import { getVersionInfo } from "./config/version";

// Log version info for production
console.log('🚀 Amlo App Starting...', getVersionInfo());

// Enhanced service worker registration with manual update control
const updateSW = registerSW({
  onOfflineReady() {
    console.log("✅ App is ready to work offline");
  },
  onNeedRefresh() {
    console.log("🔄 New content available, but waiting for user action...");
    // Don't auto-update, let user decide
    // updateSW(true); // Commented out to allow manual control
  },
  onUpdateFound() {
    console.log("📦 Update found, preparing to update...");
  },
  immediate: false, // Don't update immediately, wait for user action
});

// Listen for service worker messages
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data && event.data.type === 'SKIP_WAITING') {
      console.log('🔄 Skipping waiting, updating app...');
      window.location.reload();
    }
  });

  // Force check for updates on app start
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      registration.update();
    });
  });
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <ErrorBoundary>
      <NavigationErrorBoundary>
        <AuthProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </AuthProvider>
      </NavigationErrorBoundary>
    </ErrorBoundary>
  </React.StrictMode>
);
